import { ApiClientErrorResponse } from '~/ApiClient';

export default class PasswordResetErrorResponse extends ApiClientErrorResponse {
	handlePasswordResetNotFound(): boolean {
		return this.handle('password-reset-not-found');
	}

	handleUnknownEmail(): boolean {
		return this.handle('unknown-email');
	}

	handleAuthenticationExpiredAccount(): boolean {
		return this.handle('authentication-expired-account');
	}

	handleAuthenticationAccountDeactivated(): boolean {
		return this.handle('authentication-account-deactivated');
	}
}
